<template>
  <div class="popover">
    <template v-if="isSelf">
      <template v-if="userCanEditName">
        <div class="popover-heading">Your snake name</div>
        <div class="popover-content">
          <p>Want to claim your real snake name?</p>
          <p style="text-align:center;margin-top: 20px">
            <a class="img-a-button" @click="$emit('openEditNameModal')">
              <img
                src="@/assets/btn-claim-name.png"
                alt="Open edit name dialog"
              />
            </a>
          </p>
        </div>
      </template>

      <template v-else>
        <div class="popover-heading">Your Points</div>
        <div class="popover-content">
          <p>Share to get more points from your friends!</p>
          <p style="text-align:center;margin-top: 20px">
            <a class="img-a-button" @click="$emit('openShareModal')">
              <img src="@/assets/btn-share.png" alt="Open share dialog" />
            </a>
          </p>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="popover-heading">{{ player.name }} - Points</div>
      <div class="popover-content">
        <p>
          HIGHSCORE: <span>{{ player.baseScore }}pts</span>
        </p>
        <p>
          FROM FRIENDS: <span>{{ player.bonusPoints }}pts</span>
        </p>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ["player", "isSelf", "userCanEditName"]
};
</script>

<style lang="scss" scoped>
.popover {
  &::before {
    content: "";
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-right: 8px solid #231b4d;
    position: absolute;
    left: -7px;
    top: calc(50% - 7px);
  }
  display: inline-block;
  position: absolute;
  z-index: 200000;
  opacity: 1;
  width: 270px;
  .popover-heading {
    text-align: center;
    font-size: 11px;
    background: #ec008b;
    border-radius: 20px 20px 0px 0px;
    padding: 5px 17px;
  }
  .popover-content {
    font-size: 9px;
    background: #231b4d;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.5);
    border-radius: 0px 0px 20px 20px;
    width: 100%;
    padding: 10px 25px;
    span {
      float: right;
      color: $accent-color;
    }
  }
}
</style>
